import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { AuthProvider } from './AuthContext';

import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import ProtectedRoute from './components/ProtectedRoute';
import CompletaProfilo from './components/CompletaProfilo';
import AziendePartner from './pages/AziendePartner';
import AdminConfig from './pages/AdminConfig';
import AdminUsers from './pages/AdminUsers';
import AdminBusinesses from './pages/AdminBusinesses';
import AdminManagement from './pages/AdminManagement';
import AdminInsights from './pages/AdminInsights';
import AdminJobs from './pages/AdminJobs';
import AdminGuides from './pages/AdminGuides';
import Guide from './pages/Guide';
import CreateJob from './pages/CreateJob';
import JobListings from './pages/JobListings';
import JobDetail from './pages/JobDetail';
import Applicants from './pages/Applicants';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import SearchAlumni from './pages/SearchAlumni';
import StatusNotifications from './pages/StatusNotifications';
import PrivacyTerms from './pages/PrivacyTerms';
import ExportData from './pages/ExportData';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LandingPage />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/privacy-terms" element={<PrivacyTerms />} />
            
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="businesses" element={<AziendePartner />} />
                <Route path="admin-config" element={<AdminConfig />} />
                <Route path="admin/insights" element={<AdminInsights />} />
                <Route path="admin/users" element={<AdminUsers />} />
                <Route path="admin/businesses" element={<AdminBusinesses />} />
                <Route path="admin/jobs" element={<AdminJobs />} />
                <Route path="admin/guides" element={<AdminGuides />} />
                <Route path="admin/admins" element={<AdminManagement />} />
                <Route path="/admin/export" element={<ExportData />} />
                <Route path="/guida" element={<Guide />} />
                <Route path="/jobs/new" element={<CreateJob />} />
                <Route path="/jobs/edit/:id" element={<CreateJob />} />
                <Route path="/opportunita" element={<JobListings />} />
                <Route path="/opportunita/:id" element={<JobDetail />} />
                <Route path="/jobs/:jobId/applicants" element={<Applicants />} />
                <Route path="/profilo" element={<Profile />} />
                <Route path="/stato-notifiche" element={<StatusNotifications />} />
                <Route path="/search-alumni" element={<SearchAlumni />} /> {/* <-- 2. Aggiungiamo la nuova rotta */}
              </Route>
              
              <Route path="/completa-profilo" element={<CompletaProfilo />} />
            </Route>

          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;